export default __webpack_public_path__ + "static/field-watch-7461d193b0e28b2ff296a3724e91c6d7.jpg";